function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M7 0C3.1 0 0 3.1 0 7c0 1.9.7 3.7 2.1 5 .1.1 4.1 3.7 4.2 3.8.4.3 1 .3 1.3 0 .1-.1 4.2-3.7 4.2-3.8 1.4-1.3 2.1-3.1 2.1-5 .1-3.9-3-7-6.9-7zm0 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z",
  fill: "#42BBA3"
});

function SvgLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTYiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8cGF0aCBkPSJNNyAwQzMuMSAwIDAgMy4xIDAgN2MwIDEuOS43IDMuNyAyLjEgNSAuMS4xIDQuMSAzLjcgNC4yIDMuOC40LjMgMSAuMyAxLjMgMCAuMS0uMSA0LjItMy43IDQuMi0zLjggMS40LTEuMyAyLjEtMy4xIDIuMS01IC4xLTMuOS0zLTctNi45LTd6bTAgOWMtMS4xIDAtMi0uOS0yLTJzLjktMiAyLTIgMiAuOSAyIDItLjkgMi0yIDJ6IiBmaWxsPSIjNDJCQkEzIiBmaWxsLXJ1bGU9Im5vbnplcm8iLz4KPC9zdmc+Cg==";
export { SvgLocation as ReactComponent };